import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faCheckCircle,
  faExclamationCircle,
  faGlobe,
  faHome,
  faL,
  faLink,
  faPlus,
  faWindowClose,
} from "@fortawesome/free-solid-svg-icons";
import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  Form,
  Table,
} from "@themesberg/react-bootstrap";
import {
  addSpaceBetweenWords,
  confirmDeleteToast,
  confirmRequestToast,
  mapStepsWithHistory,
  sendError,
  sendSuccess,
  status,
  validateTruckStatus,
} from "../helpers/Helper";
import { Model } from "../components/Model";
import { Textbox } from "../components/Textbox";
import { SelectBox } from "../components/SelectBox";
import { API_URL_ENDPOINT } from "../appsetting";
import TextEditor from "../components/TextEditor";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useApi } from "../helpers/useApi";
import { Avatar } from "@mui/material";
import {
  faRefresh,
  faClose,
  faArrowUpRightFromSquare,
  faUpload,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";
import DropzoneUpload from "../components/DropzoneUpload";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import OffCanvas from "../components/OffCanvas";
import LoadAlert from "../components/LoadAlert";
import Bilty from "../components/Bilty";
import { LinkBilty } from "../components/LinkBilty";
import DocumentSection from "../components/pageComponents/DocumentSection";
import LoadBilty from "../components/LoadBilty";
import VerticalStepper from "../components/VerticalStepper";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { allSteps } from "../data/allSteps";

export const LoadDetail = () => {
  const callApi = useApi();
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [allowedStatus, setAllowedStatus] = useState([]);
  const [statusSteps, SetStatusSteps] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(
    allowedStatus?.[0] || ""
  );
  const [trasnsporterRequest, setTransporterRequest] = useState([]);
  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;

  const [dataLoading, setDataLoading] = useState(false);
  const [tLoading, setTLoading] = useState(false);
  const [documentModel, setDocumentModel] = useState({
    show: false,
    title: null,
    documetnid: null,
  });
  const [alertModel, setAlertModel] = useState(false);
  const [showCanvas, setShowCanvas] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(0);
  const [documetnKey, setDocumentKey] = useState(null);
  const [isBiltyGenerate, setIsBiltyGenerate] = useState(false);
  const [assignedTruckValidation, setAssignedTruckValidation] = useState(null);
  const [truckValidation, setTruckValidation] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      setDataLoading(true);
      const response = await callApi(API_URL_ENDPOINT.Load + `/${id}`);
      if (response.status) {
        const stepsForStepper = mapStepsWithHistory(
          allSteps,
          response?.data?.loadStatusHistories
        );
        console.log("step", stepsForStepper)
        SetStatusSteps(stepsForStepper);
        getAllowedStatusData();
        getTransporterRequestData();
        setData(response?.data ?? {});
        const result = validateTruckStatus(response?.data?.transporter?.truck);
        setAssignedTruckValidation(result);
      }
    } catch {
      setData({});
    } finally {
      setDataLoading(false);
    }
  };

  const getTransporterRequestData = async () => {
    try {
      setTLoading(true);
      const response = await callApi(
        API_URL_ENDPOINT.TransporterLoadRequest + `/${id}`
      );
      if (response.status) {
        const transporterData = response?.data ?? {};
        setTransporterRequest(transporterData);

        // Map trucks with validation
        const trucksWithValidation = transporterData.map(item => {
          var truck = item.truck;
          // Call validateTruckStatus with the single truck or whatever logic is needed
          const validationResult = validateTruckStatus(truck); // pass single truck if function supports it
          return {
            validation: validationResult,
            truckId: truck.id,
          };
        });
        // Set state once
        setTruckValidation(trucksWithValidation);
      }

    } catch {
      setTransporterRequest([]);
    } finally {
      setTLoading(false);
    }
  };

  const getAllowedStatusData = async () => {
    try {
      setTLoading(true);
      const response = await callApi(
        API_URL_ENDPOINT.Load + `/allowed-status/${id}`
      );
      if (response.status) {
        setAllowedStatus(response?.data ?? []);
        setSelectedStatus(response.data[0]);
      }
    } catch {
      setAllowedStatus([]);
    } finally {
      setTLoading(false);
    }
  };

  const updateStatus = async (status) => {
    try {
      const response = await callApi(
        API_URL_ENDPOINT.Load + `/status/${id}/${status}`,
        { method: "PUT" }
      );
      if (response.status) {
        // setData(response?.data ?? {});
        sendSuccess(response.message);
        getData();
      } else {
        throw new Error(response.message || "Somthing Went Wrong.");
      }
    } catch (ex) {
      sendError(ex.message || "Something Went Wrong.");
    } finally {
      // setDataLoading(false);
    }
  };

  const cancellLoad = async () => {
    try {
      const response = await callApi(API_URL_ENDPOINT.Load + `/cancel/${id}`, {
        method: "POST",
      });
      if (response.status) {
        // setData(response?.data ?? {});
        sendSuccess(response.message);
        getData();
      }
    } catch {
      setData({});
    } finally {
      // setDataLoading(false);
    }
  };

  const assignTransporter = async () => {
    try {
      if (selectedRequest == 0 || !id) return;
      const response = await callApi(
        API_URL_ENDPOINT.Load + `/assign-transporter/${id}/${selectedRequest}`,
        { method: "POST" }
      );
      if (response.status) {
        // setData(response?.data ?? {});
        sendSuccess(response.message);
        getData();
      }
    } catch {
      setData({});
    } finally {
      // setDataLoading(false);
    }
  };

  const onAlertSubmit = async (data) => {
    try {
      const payload = {
        ID: parseInt(data.id, 10) || 0,
        Type: parseInt(data.type, 10) || 0,
        User: parseInt(data.user, 10) || 0,
        Message: data.message,
      };

      const response = await callApi(
        API_URL_ENDPOINT.Load + "/add-alert/" + id,
        {
          method: "POST",
          data: payload,
        }
      );
      if (response.status) {
        setAlertModel(false);
        reset();
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  const removeAlert = async (alertID) => {
    try {
      const response = await callApi(
        API_URL_ENDPOINT.Load + "/remove-alert/" + alertID,
        {
          method: "POST",
          data: null,
        }
      );
      if (response.status) {
        reset();
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  const UploadFile = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file); // append the actual file
      formData.append("type", "load"); // add type field

      const response = await callApi(API_URL_ENDPOINT.Document + "/upload", {
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.status) {
        // sendSuccess(response.message);
        const documentKey = response.data?.fileKey || null;
        setDocumentKey(documentKey);
        return documentKey;
      } else {
        throw new Error(response.message || "Something went wrong");
      }
    } catch (ex) {
      sendError(ex.message);
      return null;
    }
  };

  const RemoveFile = async (key) => {
    try {
      const response = await callApi(
        API_URL_ENDPOINT.Document + "/delete?key=" + encodeURIComponent(key),
        {
          method: "POST",
          data: null,
        }
      );
      if (response.status) {
        setDocumentKey(null);
        // sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  const uploadDocument = async () => {
    try {
      const response = await callApi(API_URL_ENDPOINT.Load + `/add-document`, {
        method: "POST",
        data: {
          DocumetnKey: documetnKey,
          LoadID: id,
          DocumentID: documentModel?.documetnid,
        },
      });
      if (response.status) {
        setDocumentKey(null);
        sendSuccess(response.message);
        setDocumentModel({
          show: false,
          title: null,
          documetnid: null,
        });
        getData();
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  const onBiltyAssigned = () => {
    setIsBiltyGenerate(false);
    setShowCanvas(false);
    getData();
  };

const popover = (truckId, truckValidationArr) => {
  // Find validation for this truck
  const truckValidation = truckValidationArr?.find(t => t.truckId === truckId);

  return (
    <Popover id="invalid-popover">
      <Popover.Header
        as="h6"
        style={{ fontSize: 14 }}
        className="bg-danger text-white p-1 px-3"
      >
        Missing / Expired
      </Popover.Header>
      <Popover.Body className="p-1">
        <ul className="mb-0 ps-3" style={{ fontSize: 12 }}>
          {truckValidation?.validation?.issues?.map((item, index) => (
            <li key={index} className="text-danger" style={{ fontSize: 12 }}>
              {item}
            </li>
          ))}
        </ul>
      </Popover.Body>
    </Popover>
  );
};


  return (
    <>
      <Model show={documentModel?.show} size={"md"}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">{documentModel?.title || "Upload Document"}</h5>
          <Button
            variant=""
            style={{ width: 30, height: 30, outline: "none" }}
            className="btn-sm rounded-circle"
            onClick={() =>
              setDocumentModel({
                show: false,
                title: null,
                documetnid: null,
              })
            }
          >
            <FontAwesomeIcon icon={faClose} />
          </Button>
        </div>
        <DropzoneUpload
          onUpload={UploadFile}
          onRemove={RemoveFile}
          acceptedExtensions={[".pdf"]}
          allowMultiple={false}
        />
        <button
          onClick={uploadDocument}
          className="btn btn-primary w-100 mt-3"
          disabled={!documetnKey}
        >
          {" Upload Document"}
        </button>
      </Model>

      {/* Alert Model */}
      <Model show={alertModel} size={"md"}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Add Alert</h5>
          <Button
            variant=""
            style={{ width: 30, height: 30, outline: "none" }}
            className="btn-sm rounded-circle"
            onClick={() => setAlertModel(false)}
          >
            <FontAwesomeIcon icon={faClose} />
          </Button>
        </div>
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(onAlertSubmit)}>
            <div className="row">
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <SelectBox
                    Label="Alert Type"
                    name={"type"}
                    validationRules={{ required: "Type is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  >
                    <option value={""}>Select Alert Type</option>
                    <option value={"1"}>Green</option>
                    <option value={"2"}>Red</option>
                    <option value={"3"}>Blue</option>
                  </SelectBox>
                </Form.Group>
              </div>
              <div className="col-md-12 mb-3">
                <Form.Label>
                  Select User<span style={{ color: "red" }}>*</span>
                </Form.Label>
                <br />
                <div className="d-flex">
                  <div className="d-flex me-3">
                    <input
                      {...register("user", { required: "User is required" })}
                      type="radio"
                      value={"1"}
                      style={{ width: 20, height: 20 }}
                      className="form-check-input shadow-none me-2 mt-0"
                    />
                    <span>Shipper</span>
                  </div>
                  <div className="d-flex me-3">
                    <input
                      {...register("user", { required: "User is required" })}
                      type="radio"
                      value={"2"}
                      style={{ width: 20, height: 20 }}
                      className="form-check-input shadow-none me-2 mt-0"
                    />
                    <span>Assigned Transporter</span>
                  </div>
                  <div className="d-flex">
                    <input
                      {...register("user", { required: "User is required" })}
                      type="radio"
                      value={"0"}
                      style={{ width: 20, height: 20 }}
                      className="form-check-input shadow-none me-2 mt-0"
                    />
                    <span>Both</span>
                  </div>
                </div>
                {errors["user"] && (
                  <div className="text-danger">{errors["user"]?.message}</div>
                )}
              </div>
              <div className="col-md-12">
                <Form.Group className="mb-3">
                  <TextEditor
                    preview={true}
                    setValue={setValue}
                    Label="Message"
                    validationRules={{ required: "Message is required" }}
                    name={"message"}
                    watch={watch}
                    register={register}
                    errors={errors}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="text-end">
              <Button
                type="Button"
                className="me-2 btn-sm"
                variant="outline-danger"
                onClick={() => setAlertModel(false)}
              >
                Close
              </Button>
              <Button
                type="submit"
                className="btn-sm"
                disabled={isSubmitting}
                variant="success"
              >
                Save Changes
              </Button>
            </div>
          </Form>
        </FormProvider>
      </Model>

      <OffCanvas
        show={showCanvas}
        placement="end"
        handleClose={() => {
          setShowCanvas(false);
          setIsBiltyGenerate(false);
        }}
        width="100%"
        title={isBiltyGenerate ? "Genrate Bilty" : "Assign Existing Bilty"}
      >
        {isBiltyGenerate ? (
          <LoadBilty LoadDetail={data} />
        ) : (
          <LinkBilty
            onBiltyAssigned={() => onBiltyAssigned()}
            loadid={id}
            onBiltyGenerate={() => setIsBiltyGenerate(true)}
          />
        )}
      </OffCanvas>

      <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex">
              <Button
                variant=""
                style={{ width: 30, height: 30, outline: "none" }}
                onClick={() => navigate(-1)}
                className="btn-sm rounded-circle"
              >
                {<FontAwesomeIcon icon={faArrowLeft} />}
              </Button>
              <h4 className="mb-0 ms-3">Load Details</h4>
            </div>
            {/* {!dataLoading && ( */}
            <div>
                <Button
                  variant="primary"
                  style={{ outline: "none" }}
                  onClick={() => setAlertModel(true)}
                  className="btn-sm rounded-circle"
                >
                  <FontAwesomeIcon icon={faPlus} className="me-1" />
                  Add Alert
                </Button>
            </div>

            {/* )} */}
          </div>
        </div>
      </div>

      {!dataLoading &&
        data?.loadAlert?.length > 0 &&
        data.loadAlert.map((item, index) => (
          <LoadAlert
            key={index}
            alert={item}
            onDismiss={() => confirmDeleteToast(() => removeAlert(item.id))}
          />
        ))}

      <div className="row">
        <div className={"col-md-6 d-flex"}>
          <Card border="light" className="shadow-sm mb-4 flex-fill">
            <Card.Body className="py-3">
              <div className="d-flex justify-content-between">
                <h6 className="pb-2 mb-3">Shipper Info : </h6>
                <div>
                  <Button
                    variant="primary"
                    className="btn-sm"
                    onClick={() => getData()}
                  >
                    <FontAwesomeIcon icon={faRefresh} /> Refresh
                  </Button>
                </div>
              </div>
              <div className="d-flex justify-content-center mb-2 pb-2">
                <Avatar
                  src={data?.shipper?.profilePhoto}
                  sx={{ width: 90, height: 90 }}
                />
              </div>
              <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                <div>Shipper Name</div>
                <div style={{ fontSize: 14 }} className="text-end">
                  {dataLoading ? (
                    <Skeleton height={20} width={250} />
                  ) : (
                    <>
                      <div className="d-flex flex-column">
                        <span>
                          {data?.shipper?.fullName}{" "}
                          {data?.shipper?.isIdentityVerified ? (
                            <FontAwesomeIcon
                              title="KYC Verified"
                              className="text-success"
                              icon={faCheckCircle}
                            />
                          ) : (
                            <FontAwesomeIcon
                              title="KYC UnVerified"
                              className="text-warning"
                              icon={faExclamationCircle}
                            />
                          )}
                        </span>
                        {!dataLoading && (
                          <Link to="/" style={{ fontSize: 12 }}>
                            View Profile{" "}
                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                          </Link>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                <div>Company Name</div>
                <div style={{ fontSize: 14 }} className="text-end">
                  {dataLoading ? (
                    <Skeleton height={20} width={250} />
                  ) : (
                    <>
                      <div>{data?.shipper?.companyName || "-"}</div>
                    </>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                <div>Mobile</div>
                <div style={{ fontSize: 14 }} className="text-end">
                  {dataLoading ? (
                    <Skeleton height={20} width={150} />
                  ) : (
                    data?.shipper?.phoneNumber
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                <div>Email</div>
                <div style={{ fontSize: 14 }} className="text-end">
                  {dataLoading ? (
                    <Skeleton height={20} width={150} />
                  ) : (
                    <>
                      {data?.shipper?.email}
                      {"-"}
                    </>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                <div>Service</div>
                <div style={{ fontSize: 14 }} className="text-end">
                  {dataLoading ? (
                    <Skeleton height={20} width={100} />
                  ) : (
                    data?.shipper?.servicePercent || "-"
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                <div>Payment</div>
                <div style={{ fontSize: 14 }} className="text-end">
                  {dataLoading ? (
                    <Skeleton height={20} width={100} />
                  ) : (
                    data?.shipper?.paymentPercent || "-"
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                <div>Rating</div>
                <div style={{ fontSize: 14 }} className="text-end">
                  {dataLoading ? (
                    <Skeleton height={20} width={100} />
                  ) : (
                    data?.shipper?.ratingCount || "-"
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                <div>Order Completed</div>
                <div style={{ fontSize: 14 }} className="text-end">
                  {dataLoading ? (
                    <Skeleton height={20} width={100} />
                  ) : (
                    data?.shipper?.orderCompleted || "0"
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-between mb-2 pb-2 border-bottom">
                <div>Order Cancelled</div>
                <div style={{ fontSize: 14 }} className="text-end">
                  {dataLoading ? (
                    <Skeleton height={20} width={100} />
                  ) : (
                    data?.shipper?.orderCancelled || "0"
                  )}
                </div>
              </div>
            </Card.Body>
          </Card>
        </div>
        <div className="col-md-6 d-flex">
          <Card border="light" className="shadow-sm mb-4 flex-fill">
            <Card.Body className="py-3">
              <div className="text-end">
                {dataLoading ? (
                  <Skeleton height={25} width={100} />
                ) : (
                  <>
                    <select
                      className="rounded-pill px-2 outline-none py-1"
                      value={selectedStatus}
                      onChange={(e) => setSelectedStatus(e.target.value)}
                      style={{ fontSize: 12 }}
                    >
                      {allowedStatus?.map((item, index) => (
                        <option key={index} value={item}>
                          {addSpaceBetweenWords(item)}
                        </option>
                      ))}
                    </select>
                    {data?.status != selectedStatus && (
                      <button
                        className="rounded-pill border-1 px-2 ms-2 bg-primary py-1 text-white border-primary"
                        style={{ fontSize: 12 }}
                        onClick={() =>
                          confirmRequestToast(
                            () => updateStatus(selectedStatus),
                            "Confirm",
                            "Are You Sure to Update Status"
                          )
                        }
                      >
                        Update Status
                      </button>
                    )}
                  </>
                )}
              </div>
              {dataLoading ? (
                <div className="text-center my-3">
                  <span
                    className="spinner-border text-primary"
                    role="status"
                  ></span>
                </div>
              ) : (
                <VerticalStepper steps={statusSteps} />
              )}
            </Card.Body>
          </Card>
        </div>
        <div className="col-md-12">
          <Card border="light" className="shadow-sm mb-4">
            <Card.Body className="py-3">
              <div className="d-flex justify-content-between">
                <h6 className="">Load Info : </h6>
                <div>
                  {dataLoading ? (
                    <Skeleton height={25} width={100} />
                  ) : (
                    status(data?.status)
                  )}
                </div>
              </div>
              {dataLoading ? (
                <div className="text-center my-3">
                  <span
                    className="spinner-border text-primary"
                    role="status"
                  ></span>
                </div>
              ) : (
                <div className="row">
                  {/* Pickup Info */}
                  <div className="col-md-3 mb-3">
                    <h6 className="fw-bold bg-primary p-2 text-white pb-1 mb-2 text-center">
                      Pickup Info
                    </h6>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Address:</strong>{" "}
                      <div className="text-end">
                        {data?.sourceAddress ? (
                          `${data.sourceAddress},`
                        ) : (
                          <span style={{ fontSize: 12, color: "red" }}>
                            (Full Address Not Available)
                          </span>
                        )}
                        <div className="text-end">
                          {data?.source?.placeName &&
                            `${data.source.placeName}, `}
                          {data?.source?.city?.cityName &&
                            `${data.source.city.cityName}, `}
                          {data?.source?.city?.state?.stateName ?? ""}
                          <br />
                          {data?.source?.code && `${data.source.code}`}
                        </div>
                      </div>
                    </div>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Location URL:</strong>
                      {data?.sourceMapUrl && (
                        <a
                          href={data?.sourceMapUrl}
                          className="fw-bold"
                          target="_blank"
                        >
                          View Map
                        </a>
                      )}
                    </div>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Contact:</strong>{" "}
                      {data?.pikUpContactPerson ?? "-"}
                    </div>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Phone:</strong> {data?.pickUpContactNumber ?? "-"}
                    </div>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Pikup Time:</strong>
                      <div className="text-end">{data?.pikUpDateTime}</div>
                    </div>
                  </div>

                  {/* Drop Info */}
                  <div className="col-md-3 mb-3">
                    <h6 className="fw-bold bg-success p-2 text-white pb-1 mb-2 text-center">
                      Drop Info
                    </h6>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Address:</strong>{" "}
                      <div className="text-end">
                        {data?.destinationAddress ? (
                          `${data.destinationAddress},`
                        ) : (
                          <span style={{ fontSize: 12, color: "red" }}>
                            (Full Address Not Available)
                          </span>
                        )}
                        <div>
                          {data?.destination?.placeName &&
                            `${data.destination.placeName}, `}
                          {data?.destination?.city?.cityName &&
                            `${data.destination.city.cityName}, `}
                          {data?.destination?.city?.state?.stateName ?? ""}
                          <br />
                          {data?.destination?.code &&
                            `${data.destination.code}`}
                        </div>
                      </div>
                    </div>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Location URL:</strong>
                      {data?.destinationMapUrl && (
                        <a
                          href={data?.destinationMapUrl}
                          className="fw-bold"
                          target="_blank"
                        >
                          View Map
                        </a>
                      )}
                    </div>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Contact:</strong>
                      <div className="text-end">
                        {data?.deliveryContactPerson ?? "-"}
                      </div>
                    </div>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Phone:</strong>
                      <div className="text-end">
                        {data?.deliveryContactNumber ?? "-"}
                      </div>
                    </div>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Drop Time:</strong>
                      <div className="text-end">
                        {data?.deliveryDateTime ?? "-"}
                      </div>
                    </div>
                  </div>

                  {/* Product Info */}
                  <div className="col-md-3 mb-3">
                    <h6 className="fw-bold bg-danger p-2 text-white pb-1 mb-2 text-center">
                      Product Info
                    </h6>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Product :</strong> {data?.product}
                    </div>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Weight :</strong> {data?.weightInTons + " Ton"}
                    </div>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Rate :</strong>
                      <div>
                        {data?.rateAmount}{" "}
                        <span style={{ fontSize: 10 }}>({data?.rateType})</span>
                      </div>
                    </div>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Payment Term :</strong> {data?.paymentTerms}
                    </div>
                    <div
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                      style={{ fontSize: 14 }}
                    >
                      <strong>Required Truck :</strong> {data?.truckType?.name}
                    </div>
                  </div>

                  {/* Assigned Truck Info */}
                  <div className="col-md-3 mb-3">
                    <h6 className="fw-bold bg-primary p-2 text-white pb-1 mb-2 text-center">
                      Assigned Truck
                    </h6>
                    {data?.transporter ? (
                      <>
                        <div
                          className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                          style={{ fontSize: 14 }}
                        >
                          <strong>Truck No:</strong>
                          <div>
                            {data?.transporter?.truck?.regNumber ?? "-"}
                            {truckValidation?.find(t => t.truckId === data?.transporter?.truck?.id)?.validation?.isValid === false && (
                              <OverlayTrigger
                                trigger="click"
                                placement="top"
                                overlay={popover(data?.transporter?.truck?.id, truckValidation)}
                                rootClose
                              >
                                <FontAwesomeIcon
                                  icon={faExclamationCircle}
                                  className="ms-2 text-danger"
                                  style={{ cursor: "pointer" }}
                                />
                              </OverlayTrigger>
                            )}
                          </div>
                        </div>
                        <div
                          className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                          style={{ fontSize: 14 }}
                        >
                          <strong>Truck Type:</strong>
                          <div className="text-end">
                            {data?.transporter?.truck?.truckTypes?.name ?? "-"}
                          </div>
                        </div>
                        <div
                          className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                          style={{ fontSize: 14 }}
                        >
                          <strong>Transporter Name:</strong>
                          <div className="text-end">
                            {data?.transporter?.transporter?.fullName ?? "-"}
                          </div>
                        </div>
                        <div
                          className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                          style={{ fontSize: 14 }}
                        >
                          <strong>Transporter Phone:</strong>
                          {data?.transporter?.transporter?.phoneNumber ?? "-"}
                        </div>
                        <div
                          className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                          style={{ fontSize: 14 }}
                        >
                          <strong>Owner Name:</strong>{" "}
                          {data?.transporter?.truck?.ownerName ?? "-"}
                        </div>
                        <div
                          className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                          style={{ fontSize: 14 }}
                        >
                          <strong>Owner Phone:</strong>{" "}
                          {data?.transporter?.truck?.contactNumber ?? "-"}
                        </div>
                        <div
                          className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                          style={{ fontSize: 14 }}
                        >
                          <strong>Driver Name:</strong> Mohan Singh
                        </div>
                        <div
                          className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                          style={{ fontSize: 14 }}
                        >
                          <strong>Driver Phone:</strong> +91-9876123456
                        </div>
                        <div
                          className="d-flex justify-content-between mb-2 pb-2 border-bottom"
                          style={{ fontSize: 14 }}
                        >
                          <strong>Driver DL:</strong> +91-9876123456
                        </div>
                      </>
                    ) : (
                      <div className="text-center text-light mt-5 pt-2">
                        <FontAwesomeIcon
                          style={{ fontSize: 40 }}
                          icon={faWindowClose}
                        />
                        <div className="text-center" style={{ fontSize: 14 }}>
                          Not Assigned Yet.
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        </div>

        <DocumentSection
          data={data}
          setShowCanvas={setShowCanvas}
          setDocumentModel={setDocumentModel}
          status={status}
        />

        {data?.status != "PendingApproval" && !dataLoading && (
          <div className="col-md-12">
            <Card border="light" className="shadow-sm mb-4">
              <Card.Body className="py-3">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="m-0">
                    Booking Request : {`(${trasnsporterRequest?.length || 0})`}
                  </h6>
                  {selectedRequest != 0 && (
                    <button
                      className="btn btn-success btn-sm me-2"
                      onClick={() =>
                        confirmRequestToast(
                          () => assignTransporter(),
                          "Confirm Assign",
                          "Are you sure you want to assign this Transporter? Once Assigned, it can't be changed.",
                          "Confirm"
                        )
                      }
                    >
                      <FontAwesomeIcon className="me-1" icon={faCheckCircle} />{" "}
                      Assign Transporter
                    </button>
                  )}
                </div>
                <Table
                  responsive
                  className="table-centered table-nowrap rounded mb-0"
                >
                  <thead className="thead-light">
                    <tr>
                      {(data?.assignedTransporterRequestID == null ||
                        data?.assignedTransporterRequestID == 0) && (
                        <th className="border-0 text-center"></th>
                      )}
                      <th className="border-0 text-center">#</th>
                      <th className="border-0 text-center">Transporter</th>
                      <th className="border-0">Truck Reg. No.</th>
                      <th className="border-0">Truck Type (Capacity)</th>
                      <th className="border-0 text-center">Mobile No.</th>
                      <th className="border-0 text-center">Status</th>
                      <th className="border-0 text-center">Created AT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tLoading ? (
                      <tr>
                        <td colSpan="8">
                          <div className="text-center my-3">
                            <span
                              className="spinner-border text-primary"
                              role="status"
                            ></span>
                          </div>
                        </td>
                      </tr>
                    ) : trasnsporterRequest?.length > 0 ? (
                      trasnsporterRequest?.map((item, index) => {
                        return (
                          <tr key={index}>
                            {(data?.assignedTransporterRequestID == null ||
                              data?.assignedTransporterRequestID == 0) && (
                              <td className="text-center align-middle">
                                <input
                                  onChange={() => setSelectedRequest(item.id)}
                                  checked={selectedRequest === item.id}
                                  type="radio"
                                  style={{ width: 20, height: 20 }}
                                  className="form-check-input shadow-none"
                                  name="transporter"
                                />
                              </td>
                            )}
                            <td className="text-center align-middle">
                              {index + 1}
                            </td>
                            <td className="fw-bold align-middle text-center">
                              {item.transporter?.fullName || "-"}
                            </td>
                            <td className="fw-bold align-middle">
                              {item.truck?.regNumber}
                              {truckValidation?.find(t => t.truckId === item.truck?.id)?.validation?.isValid === false && (
                                <OverlayTrigger
                                  trigger="click"
                                  placement="top"
                                  overlay={popover(item.truck?.id, truckValidation)}
                                  rootClose
                                >
                                  <FontAwesomeIcon
                                    icon={faExclamationCircle}
                                    className="ms-2 text-danger"
                                    style={{ cursor: "pointer" }}
                                  />
                                </OverlayTrigger>
                              )}
                            </td>
                            <td className="fw-bold align-middle">
                              {item.truck?.truckType?.name} (
                              {item.truck?.loadCapacityInTons || 0} Ton)
                            </td>
                            <td className="fw-bold align-middle text-center">
                              {item.transporter?.phoneNumber || "-"}
                            </td>
                            <td className="fw-bold align-middle text-center">
                              {status(item.status)}
                            </td>
                            <td className="fw-bold align-middle text-center">
                              {item.createdAt}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </div>
        )}
      </div>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="py-3">
          <div className="d-flex justify-content-between">
            <h6 className="pb-2 mb-3">Data Change Log : </h6>
            {/* <div>{status("Pending")}</div> */}
          </div>
          <Table
            responsive
            className="table-centered table-nowrap rounded mb-0"
          >
            <thead className="thead-light">
              <tr>
                <th className="border-0 text-center">#</th>
                <th className="border-0 text-center">Transporter</th>
                <th className="border-0">Truck Reg. No.</th>
                <th className="border-0">Truck Type</th>
                <th className="border-0 text-center">Status</th>
                <th className="border-0 text-center">Created AT</th>
                <th className="border-0 text-end pe-4">Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.items?.length > 0 ? (
                data?.items.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center align-middle">
                      {(data.pageNo - 1) * data.pageSize + index + 1}
                    </td>
                    <td className="fw-bold align-middle text-center">
                      {item.createdAt || "-"}
                    </td>
                    <td className="fw-bold align-middle">
                      {item.source?.placeName}
                    </td>
                    <td className="fw-bold align-middle">
                      {item.destination?.placeName}
                    </td>
                    <td className="fw-bold align-middle text-center">
                      {item.shipper?.companyName || item.shipper?.fullName}
                    </td>
                    <td className="fw-bold align-middle text-center">
                      {item.product}
                    </td>
                    <td className="align-middle text-center">
                      {status(item.status)}
                    </td>
                    <td className="text-end align-middle">
                      {/* <Button variant="primary" className="btn-sm" onClick={()=>handleView(item.id)}>View Details</Button> */}
                      {/* <Button onClick={handleDelete} variant="danger" className="btn-sm">Remove</Button> */}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </>
  );
};
